// Wrapper sûr : window.umami est absent en dev (pas d'env vars) ou si bloqué par le navigateur.
export function track(name, data = {}) {
  try {
    window.umami?.track(name, data)
  } catch (_) {
    // l'analytics ne doit jamais casser l'UI
  }
}
